var exports = {
  "wx": "xfd349460--83f057--header",
  "vn": "xfd349460--83f057--header-aside",
  "DB": "xfd349460--83f057--compilations",
};

module.exports = exports;
